function setupSalesPage() {
  console.log('Setting up sales page');

  document.querySelector('body').classList.add('sales-page');

  document.querySelectorAll('.sca_aff_customer_refer_container').forEach((container) => {
    container.style.display = 'none !important';
    container.remove();
  });

  document.querySelectorAll('#gorgias-chat-container').forEach((container) => {
    container.style.display = 'none !important';
    container.remove();
  });

  // document.querySelectorAll('.header-top > nav.header-menu').forEach(container => {
  //   container.style.display = 'none';
  // });
}

window.setupSalesPage = setupSalesPage;
